import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const ACADEMIC_PERIOD = 'academic_period'
const GROUP = 'group'
const SCHEDULE_FILE = 'schedule_file'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [ACADEMIC_PERIOD]: {
      label: `${t('school.academic-period')}`,
      name: ACADEMIC_PERIOD,
      required: true,
    },
    [GROUP]: {
      label: `${t('common.group')}`,
      name: GROUP,
      required: true,
    },
    [SCHEDULE_FILE]: {
      label: `${t('common.schedule-file')}`,
      name: GROUP,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [ACADEMIC_PERIOD]: null,
  [GROUP]: null,
  [SCHEDULE_FILE]: ''

}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [ACADEMIC_PERIOD]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [GROUP]: yup
      .object()
      .required(`${t('errors.required-error-message')}`)
      .typeError('errors.invalid-date-message'),
  })

export default formModel
